// DEV-389: never show a false "$0.00" price. Keep in step with
// PremiumBreakdownPopover's cannotCalculate.
export type PlanCardPriceState = "loading" | "unavailable" | "ready";

type PremiumTotals = { totalMonthlyRate?: number | string | null; employeePremium?: number | string | null };

/**
 * True when there's no real price: no result, or both the total rate and the
 * employee share are 0. A fully employer-paid plan (employee $0, total > 0)
 * is a real $0.00 and is NOT unpriced.
 */
export function isUnpricedPremium(result: PremiumTotals | null | undefined): boolean {
  return !result || !(Number(result.totalMonthlyRate) > 0 || Number(result.employeePremium) > 0);
}

export function planCardPriceState(
  result: PremiumTotals | null | undefined,
  isLoading: boolean,
): PlanCardPriceState {
  if (isLoading) return "loading";
  if (isUnpricedPremium(result)) return "unavailable";
  return "ready";
}
